import { FEATURE_FLAGS } from 'app/shared/constants/feature-flags.constants';

export const POLICIES_PROCEDURES_AI_BUILDER_FLAG = FEATURE_FLAGS.POLICIES_PROCEDURES_AI_BUILDER;

export type PolicyDocumentKind = 'policy' | 'procedure';
export type PolicyCreateMethod = 'describe' | 'paste' | 'upload' | 'blank';
export type PolicyCreationSource = 'BlankTemplate' | 'AiDescribe' | 'AiPaste' | 'AiUpload';

export interface PolicyWorkspacePage {
	items: PolicyWorkspaceListItem[];
	totalCount: number;
	page: number;
	pageSize: number;
}

export const WORKSPACE_PAGE_SIZE = 50;

export interface PolicyWorkspaceListItem {
	id: string;
	kind: PolicyDocumentKind | string;
	name: string;
	number: string;
	version?: string;
	workflowStep?: string;
	declinedReason?: string;
	isDraft?: boolean;
	createdDate?: string;
	needsUpdate?: boolean;
	policyId?: string;
	labelIds?: string[];
}

export const creationSourceFromMethod = (method: PolicyCreateMethod): PolicyCreationSource => {
	switch (method) {
		case 'describe':
			return 'AiDescribe';
		case 'paste':
			return 'AiPaste';
		case 'upload':
			return 'AiUpload';
		default:
			return 'BlankTemplate';
	}
};
